<template>
  <li class="d-flex justify-content-between align-items-start p-0">
    <div class="ms-0 w-100">
      <section
        tabindex="0"
        class="list-group-item list-group-item-action btn btn-ghost btn-sm d-flex justify-content-between align-items-center"
        :style="`padding-left: ${level * 1.5}rem;`"
        :class="[
          isRoot === true ? 'fw-bold text-body-emphasis' : 'fw-medium text-body',
          {active: active === true},
        ]"
        @keypress="handleUpdateActive(listId)"
        @click="handleUpdateActive(listId)"
      >
        <span class="d-flex justify-content-start align-items-center">
          <div class="pe-2">
            <slot name="collapseOptions" :is-open="isOpen" />
          </div>
          {{ name }}
        </span>
        <slot name="actions" />
      </section>
      <ul class="list-group list-group-flush">
        <div v-show="isOpen === true">
          <slot />
        </div>
      </ul>
    </div>
  </li>
</template>
<script lang="ts" setup>
import {
  listGroupKey,
  listGroupInjectionKey,
} from '@/components/shared/bootstrap/BootstrapListGroup/injectionKeys';

interface Props {
  listId: string;
  name: string;
  open?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  open: false,
});

const isOpen = computed(() => props.open);

const {activeListId, handleUpdateActive} = inject<listGroupKey>(
  listGroupInjectionKey,
) as listGroupKey;
const active = computed(() => activeListId.value === props.listId);
const level = computed(() => props.listId.split('-').length);
const isRoot = computed(() => level.value === 1);
</script>
<style lang="scss" scoped>
.active {
  background-color: color-mix(in srgb, var(--bs-blue-500) 7.5%, transparent);
}
</style>
